import { SessionStore } from '../../constants/sessionStore';

/** Update session storage keys usersessionactive and loggedoutuser */
export const updateSessionStorageForLoggedinUser = (candidateDeadlineDate?: string): void => {
  candidateDeadlineDate && sessionStorage.setItem(SessionStore.candidateDeadlineDate, candidateDeadlineDate);

  /** remove key loggedoutuser if present */
  sessionStorage.getItem(SessionStore.loggedoutuser) && sessionStorage.removeItem(SessionStore.loggedoutuser);
  sessionStorage.getItem(SessionStore.logoutDueToInactivity) &&
    sessionStorage.removeItem(SessionStore.logoutDueToInactivity);
};
